export const status_updates_display = {
  empty: "No status updates yet",
};
